var meta = {showLeftMenu: true, headIndex: 3, keepAlive: true};
export var router = [{
  path: '/knowledge',
  meta: {showLeftMenu: false, headIndex: 3, keepAlive: true, changed: false, isBack: false},
  name: 'knowledge',
  component: resolve => require(["./dataSearch5.vue"], resolve),
}, {
  path: '/knowledgeShow',
  meta: {showLeftMenu: false, headIndex: 3, keepAlive: false, changed: false, isBack: false},
  name: 'knowledgeShow',
  component: resolve => require(["./dataShow.vue"], resolve),
}, {
  path: '/channelKnowledge',
  meta: {showLeftMenu: false, headIndex: 3, keepAlive: true, changed: false, isBack: false},
  name: 'channelKnowledge',
  component: resolve => require(["./channelDataSearch.vue"], resolve),
}, {
  path: '/vectorKnowledge',
  meta: {showLeftMenu: false, headIndex: 3, keepAlive: true, changed: false, isBack: false},
  name: 'vectorKnowledge',
  component: resolve => require(["./dataSearch5.vue"], resolve),
  props: () => ({
    isVector: true,
  }),
}
,{
  path: '/loopholeQuery',
  meta: {showLeftMenu: false, headIndex: 3, keepAlive: true, changed: false, isBack: false},
  name: 'loopholeQuery',
  component: resolve => require(["./loopholeQuery.vue"], resolve),
  props: () => ({
    isVector: true,
  }),
}
]



// WEBPACK FOOTER //
// ./src/views/knowledge/router.js